module.exports = __webpack_public_path__ + "img/viking-logo-black.29d96ce3.svg";